import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import AgreementMeasure from '../../entities/tracing/agreementmeasure'
import Agreement from '../../entities/tracing/agreement'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface AgreementMeasureState extends ListState<AgreementMeasure>{
    editModel: AgreementMeasure;
    agreement: number;
    itemLoading: boolean;
}
class AgreementMeasureModule extends ListModule<AgreementMeasureState,any,AgreementMeasure>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<AgreementMeasure>(),
        loading: false,
        itemLoading: false,
        editModel: new AgreementMeasure(),
        activeList: new Array<AgreementMeasure>(),
        agreement: 0,
        path: 'agreement-measures'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        init(state: AgreementMeasureState, model: Agreement) {
            state.editModel = Object.assign({});
            state.agreement = 0;
            if (model != undefined) {
                state.agreement = model.id;
            }
        },
        new(state: AgreementMeasureState, model: AgreementMeasure) {
            state.editModel = Object.assign({});
            state.editModel.description = null;
        },
    });
}
const agreementmeasureModule=new AgreementMeasureModule();
export default agreementmeasureModule;
